import type { AppThunk } from '@core/core/store'
import { selectActiveProjectId } from '@core/core/store'

import { applyVelocityDomainsApi } from '../../api'
import type { DomainConvertInfo, DomainConvertObject } from '../../types'
import { velocityDomainsSlice } from './velocityDomainsSlice'

const { addVelocityDomains } = velocityDomainsSlice.actions

export const applyVelocityDomains =
  (applyingData: DomainConvertInfo): AppThunk =>
  async (dispatch, getState) => {
    const projectId = selectActiveProjectId(getState())
    try {
      const data = await applyVelocityDomainsApi(projectId, applyingData)
      const objects: DomainConvertObject[] = data.map(obj => ({
        ...obj,
        type: applyingData.objects.find(obj => obj.id === obj.id)?.type ?? 'unknown',
      }))

      dispatch(addVelocityDomains({ ...applyingData, objects }))
    } catch (error) {
      console.log(error)
    }
  }
